import { Card, CardContent, Typography, Box, useTheme } from '@mui/material'
import useCustomStyles from '../../../hooks/CustomStylesHook'
import { PieChart } from '@mui/x-charts'
import Colors from '../../../utils/colors.json'

const styles = (theme: any) => ({
  card: {
    backgroundColor: theme.palette.primary.light,
    borderRadius: '20px',

    padding: 2,
    width: '100%',
  },
  chartContainer: {
    width: '30%',
    marginTop: 10,
  },
  legend: {
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: 10,
    width: '70%',
  },
  legendItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 5,
  },
  legendColor: {
    width: 10,
    height: 10,
    borderRadius: '50%',
  },
})

const ClaimsCard = () => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)

  const data = {
    labels: ['Father', 'Mother', 'Son'],
    datasets: [
      {
        data: [12000, 8000, 20000],
        backgroundColor: ['#FFC90A', '#FFE998', '#1DBF73'],
        hoverBackgroundColor: ['#FFC90A', '#FFE998', '#1DBF73'],
        borderWidth: 2,
      },
    ],
  }

  // const options = {
  //   plugins: {
  //     legend: { display: false },
  //   },
  //   cutout: '75%',
  // }

  return (
    <Card className={classes?.card} elevation={0}>
      <CardContent>
        <Typography
          fontSize={'16px'}
          fontWeight={500}
          gutterBottom
          color={Colors.TEXT_COLOR_SECONDARY}
        >
          Claims
        </Typography>
        <Box
          display={'flex'}
          flexDirection={'row'}
          justifyContent={'space-between'}
        >
          <Box className={classes?.chartContainer}>
            <PieChart
              margin={{ right: 5 }}
              slotProps={{
                legend: {
                  hidden: true,
                },
              }}
              series={[
                {
                  data: [
                    { id: 0, value: 12000, label: 'Father', color: '#FFC90A' },
                    { id: 1, value: 8000, label: 'Mother', color: '#FFE998' },
                    { id: 2, value: 20000, label: 'Son', color: '#1DBF73' },
                  ],
                  innerRadius: 60,
                },
              ]}
              width={200}
              height={160}
            />
          </Box>
          <Box className={classes?.legend}>
            {data?.labels?.map((label, index) => (
              <Box
                key={index}
                display={'flex'}
                flexDirection={'column'}
                justifyContent={'center'}
              >
                <Box key={label} className={classes?.legendItem}>
                  <span
                    className={classes?.legendColor}
                    style={{
                      backgroundColor: data.datasets[0].backgroundColor[index],
                    }}
                  ></span>
                  <Typography variant='body2'>{`${label}`}</Typography>
                </Box>
                <Typography
                  variant='h5'
                  fontWeight={'bold'}
                >{`${data.datasets[0].data[index]}`}</Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </CardContent>
    </Card>
  )
}

export default ClaimsCard
